(() => {
  const root = document.getElementById('philo-shop-layout');
  if (!root || root.dataset.mapBound) return;
  root.dataset.mapBound = 'true';
  const canvas = root.querySelector('[data-stockist-map-canvas]');
  const frame = root.querySelector('iframe');
  const buttons = [...root.querySelectorAll('[data-stockist-map-address]')];
  let map, selected, ready = false;
  const locations = new Map();
  const active = () => buttons.filter(button => !button.closest('article').hidden);
  function fallback(button) {
    canvas.hidden = true;
    frame.style.visibility = '';
    root.dataset.mapState = 'fallback';
    if (button) frame.title = `Map — ${button.dataset.stockistMapName}`;
  }
  window.gm_authFailure = () => { ready = false; fallback(selected || active()[0]); };
  function show() {
    canvas.hidden = false;
    canvas.style.visibility = '';
    frame.style.visibility = 'hidden';
    root.dataset.mapState = 'ready';
  }
  function refreshPins() {
    locations.forEach((location, button) => {
      location.pin.setMap(button.closest('article').hidden ? null : map);
      location.pin.element?.setAttribute('aria-pressed', String(button === selected));
    });
  }
  function overview() {
    selected = null;
    if (!ready) return;
    const items = active().map(button => locations.get(button)).filter(Boolean);
    refreshPins();
    // Do not hide a store with an unresolved address behind an incomplete overview.
    if (!items.length || items.length !== active().length) return fallback(active()[0]);
    show();
    if (items.length === 1) { map.setCenter(items[0].position); map.setZoom(16); }
    else {
      const bounds = new google.maps.LatLngBounds();
      items.forEach(item => bounds.extend(item.position));
      map.fitBounds(bounds, 56);
    }
  }
  function focus(button) {
    selected = button;
    if (!ready) return;
    refreshPins();
    const location = locations.get(button);
    if (!location) return fallback(button);
    show();
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) map.setCenter(location.position);
    else map.panTo(location.position);
    map.setZoom(16);
  }
  root.addEventListener('stockist:select', event => focus(event.detail.button));
  root.addEventListener('stockist:overview', overview);
  window.seronineStockistsMapReady = async () => {
    if (!root.isConnected || ready) return;
    try {
      canvas.hidden = false;
      canvas.style.visibility = 'hidden';
      map = new google.maps.Map(canvas, {
        center: {lat: 23, lng: 120}, zoom: 4,
        disableDefaultUI: true, zoomControl: true, keyboardShortcuts: true,
        gestureHandling: 'cooperative', clickableIcons: false,
        styles: [
          {elementType:'geometry',stylers:[{color:'#eeeeee'}]},
          {elementType:'labels.text.fill',stylers:[{color:'#555555'}]},
          {elementType:'labels.text.stroke',stylers:[{color:'#ffffff'}]},
          {featureType:'poi',stylers:[{visibility:'off'}]},
          {featureType:'transit',stylers:[{visibility:'off'}]},
          {featureType:'road',elementType:'geometry',stylers:[{color:'#ffffff'}]},
          {featureType:'road',elementType:'geometry.stroke',stylers:[{color:'#d6d6d6'}]},
          {featureType:'water',elementType:'geometry',stylers:[{color:'#cccccc'}]}
        ]
      });
      class StorePin extends google.maps.OverlayView {
        constructor(position, button) { super(); this.position = position; this.button = button; }
        onAdd() {
          const element = document.createElement('button');
          element.type = 'button'; element.className = 'seronine-stockists__pin';
          element.setAttribute('aria-label', this.button.dataset.stockistMapName);
          element.setAttribute('aria-pressed', String(selected === this.button));
          element.addEventListener('click', () => {
            if (this.button.getAttribute('aria-expanded') !== 'true') this.button.click();
            else focus(this.button);
          });
          google.maps.OverlayView.preventMapHitsAndGesturesFrom(element);
          this.element = element;
          this.getPanes().overlayMouseTarget.append(element);
        }
        draw() {
          const point = this.getProjection().fromLatLngToDivPixel(this.position);
          if (point && this.element) { this.element.style.left = `${point.x}px`; this.element.style.top = `${point.y}px`; }
        }
        onRemove() { this.element?.remove(); this.element = null; }
      }
      const geocoder = new google.maps.Geocoder();
      await Promise.allSettled(buttons.map(async button => {
        const response = await Promise.race([geocoder.geocode({address:button.dataset.stockistMapAddress}),new Promise((_,reject)=>setTimeout(()=>reject(new Error('timeout')),12000))]);
        // An area centroid is not an accurate store pin. Keep the address-map fallback for it.
        const result = response.results.find(item => !item.partial_match &&
          ['ROOFTOP','RANGE_INTERPOLATED'].includes(item.geometry.location_type) &&
          item.types.some(type => ['street_address','premise','subpremise'].includes(type)));
        if (!result) {button.dataset.mapLocation = 'needs-confirmation'; return;}
        const position = result.geometry.location;
        locations.set(button, {position, pin:new StorePin(position, button)});
        button.dataset.mapLocation = 'address-resolved';
      }));
      ready = true;
      if (selected) focus(selected); else overview();
      const resize = new ResizeObserver(() => { if (!selected && ready) overview(); });
      resize.observe(canvas.parentElement);
    } catch (_) { fallback(selected || active()[0]); }
  };
})();
